<div class="form-group col cerrix-textfield">
    @if (fieldLabel && fieldLabel.length > 0) {
        <label [for]="fieldId" [class]="labelCss">{{ fieldLabel }} </label>
    }
    <textarea
        [id]="fieldId"
        [name]="fieldName"
        [ngModel]="value"
        (ngModelChange)="onValueChange($event)"
        [disabled]="disabled"
        [readonly]="readonly"
        [required]="required"
        [rows]="rows"
        [attr.data-uiid]="dataUiid"
        [placeholder]="placeholder"
        [class]="cssClass"
        [class.ng-valid]="valid"
        [class.ng-invalid]="!valid"
        [class.ng-pending]="control && control.pending"
        [class.ng-pristine]="control && control.pristine"
        [class.ng-dirty]="control && control.dirty"
        [class.ng-untouched]="control && control.untouched"
        [class.ng-touched]="control && control.touched"
        [style]="style"
        [attr.maxlength]="limitInput ? maxLength : null"
        (blur)="onBlur()"
        (keyup)="onKeyup()"
        inputTooltip
        autogrow
        [autoGrowEnabled]="autoGrowEnabled"
        #inputField
    ></textarea>
</div>
